module.exports = __webpack_public_path__ + "img/BI分析1.ed8f0b06.png";